import { IconButton, icons, Menu, MenuItem } from '../../../components/generic';
import Loader from '../../../components/generic/Loader';
import useUser from '../../hooks/useUser';
import { useIsPrivatePortalEnabled, useVisibility } from '../hooks';

import styles from './UserButton.module.less';

/**
 * This button is responsible for handling the user's authentication state.
 * It includes options to enter the private access token and sign out.
 */
const UserButton = () => {
  const { isPrivatePortalEnabled, isLoading } = useIsPrivatePortalEnabled();
  const { navigateToTab } = useVisibility();
  const { isTokenAuthenticated, removeToken } = useUser();
  if (isLoading) {
    return <Loader />;
  }

  if (!isPrivatePortalEnabled) {
    return null;
  }
  const icon = isTokenAuthenticated ? icons.userCircle : icons.userCircleRegular;

  return (
    <div className={styles.userButton}>
      <Menu menuButton={<IconButton icon={icon} id="user" onClick={() => {}} />} direction="bottom">
        {!isTokenAuthenticated && (
          <MenuItem onClick={() => navigateToTab('private')}>Enter Private Access Token</MenuItem>
        )}
        {isTokenAuthenticated && <MenuItem onClick={() => removeToken()}>Sign out token</MenuItem>}
      </Menu>
    </div>
  );
};

export default UserButton;
